export const APP_NAME = "MultiMatch";
export const GENERIC_ERROR_KEY = "generic";
export const NUTRIENT_RADIO_OPTIONS = ["P2O5 K2O", "PK"];
